import React from 'react'
import PropTypes from 'prop-types'
import {
  TextField,
  Button,
  Typography,
  Box,
} from '@mui/material'
import Autocomplete from '@mui/material/Autocomplete'
import { useTranslation } from 'react-i18next'
import { AutocompleteTextField } from './CustomerStyledComponents'
const MaterialsListVertical = ({
  materials,
  availableMaterials,
  handleAddMaterial,
  handleMaterialChange,
  handleRemoveMaterial,
  title,
  buttonTitle,
  type,
  isNotModifiable,
}) => {
  const { t } = useTranslation('order_modal')
  return (
    <div>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h5">{title}</Typography>
        <Button
          variant="outlined"
          color="primary"
          onClick={handleAddMaterial}
          disabled={isNotModifiable}
        >
          <span style={{ marginRight: '1rem' }}>+</span> {buttonTitle}
        </Button>
      </Box>
      {materials.map((material, index) => (
        <Box colSpan={4} sx={{ py: 1, display: 'flex', flexDirection: 'column', gap: 1 }} key={index}>
          <Box mb={1}>
            <Autocomplete
              options={availableMaterials}
              getOptionLabel={(option) =>
                option.internalId + ' - ' + option.description || ''
              }
              value={
                availableMaterials.find((mat) => mat.internalId === material.internalId) ||
                null
              }
              onChange={(event, value) =>
                handleMaterialChange(index, 'name', value ? value.internalId : '', type)
              }
              renderInput={(params) => (
                <AutocompleteTextField
                  {...params}
                  label={t('materialName')}
                  disabled={isNotModifiable}
                />
              )}
              renderOption={(props, option) => (
                <li {...props}>
                  {option.internalId} - {option.description}
                </li>
              )}
              clearIcon={null}
              disabled={isNotModifiable}
              noOptionsText={t('noOptions')}
              fullWidth
              sx={{
                '& svg': { position: 'static' },
              }}
            />
          </Box>
          <Box mb={1}>
            <TextField
              label={t('quantity')}
              value={material.quantity ?? 30}
              onChange={(e) => {
                const value = e.target.value
                if (/^(?:\d+(\.\d{0,3})?)?$/.test(value)) {
                  handleMaterialChange(index, 'quantity', value, type)
                }
              }}
              sx={{ width: '50%' }}
              fullWidth
              disabled={isNotModifiable}
            />
          </Box>
          <Box display="flex" gap={4} alignItems="center">
            <TextField label={t('unit')} value={material.unit} disabled sx={{ width: '50%' }} />
            <Button
              variant="contained"
              color="error"
              onClick={() => handleRemoveMaterial(index, type)}
              disabled={isNotModifiable}
            >
              x
            </Button>
          </Box>
        </Box>
      ))}
    </div>
  )
}
MaterialsListVertical.propTypes = {
  materials: PropTypes.arrayOf(
    PropTypes.shape({
      internalId: PropTypes.string.isRequired,
      quantity: PropTypes.string.isRequired,
      unit: PropTypes.string.isRequired,
    })
  ).isRequired,
  availableMaterials: PropTypes.arrayOf(
    PropTypes.shape({
      internalId: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      unit: PropTypes.string.isRequired,
    })
  ).isRequired,
  handleAddMaterial: PropTypes.func.isRequired,
  handleMaterialChange: PropTypes.func.isRequired,
  handleRemoveMaterial: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  buttonTitle: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  isNotModifiable: PropTypes.bool,
}
export default MaterialsListVertical
